const PARAGRAPH_TWITTER_BLOCK = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on TwitterBlockParagraph {
      id
      twitter_block
      type
      uuid
    }
  }
`;

export default PARAGRAPH_TWITTER_BLOCK;
